export const catalogPriceToInput = value => {
  if (value === null || value === undefined || value === '') return '';
  const amount = Number(value);
  return Number.isFinite(amount) ? (amount / 1000).toFixed(2) : '';
};

export const catalogProductImage = product =>
  product?.image_url ||
  product?.images?.[0]?.image_url ||
  product?.images?.[0]?.original_image_url ||
  '';

export const catalogProductPrice = product => {
  const amount = Number(
    product?.sale_price_amount_1000 || product?.price_amount_1000
  );
  if (!Number.isFinite(amount)) return 'Preço não informado';

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: product?.currency || 'BRL',
  }).format(amount / 1000);
};

export const catalogProductStatus = product => {
  if (product?.is_hidden)
    return { label: 'Oculto', className: 'bg-amber-50 text-amber-800' };
  if (product?.availability === 'out of stock') {
    return { label: 'Sem estoque', className: 'bg-red-50 text-red-700' };
  }

  return { label: 'Publicado', className: 'bg-emerald-50 text-emerald-700' };
};

export const catalogConnectionLabel = connection =>
  [
    connection?.profile_name || connection?.instance_name || 'WhatsApp',
    connection?.phone_number || connection?.phone,
  ]
    .filter(Boolean)
    .join(' · ');

export const catalogConnectionIsOpen = connection =>
  Boolean(
    connection?.active ||
      ['open', 'connected', 'ready'].includes(
        String(
          connection?.status || connection?.call_gateway_status || ''
        ).toLowerCase()
      )
  );
